module.exports = __webpack_public_path__ + "img/card1.5e8f1efa.png";